var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetanoStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9683 12.4085C42.8863 8.19851 37.5699 5.87891 32.0001 5.87891C26.4251 5.87891 21.1087 8.19851 17.0241 12.4111C12.8781 16.6877 10.6012 22.4334 10.7798 28.1765C11.2837 44.451 30.4537 57.1235 31.2723 57.6541L31.9895 58.1207L32.7147 57.6621C33.5305 57.1449 52.714 44.779 53.2205 28.1738C53.3965 22.4334 51.1169 16.6851 46.9683 12.4085Z",
    fill: "#FF3C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4099 26.9651C17.4099 35.0106 23.957 41.5526 32.0025 41.5526C40.048 41.5526 46.5899 35.0106 46.5899 26.9651C46.5899 18.9194 40.048 12.3721 32.0025 12.3721C23.957 12.3721 17.4099 18.9194 17.4099 26.9651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3847 28.5454C38.3847 31.2535 34.7208 33.5557 28.6033 33.5557H24.8889L27.4269 20.5557H35.5815C37.88 20.5557 39.1111 21.0276 39.1111 22.454C39.1111 24.1623 36.3684 26.0442 32.0528 26.8207L34.4066 22.9233L30.8096 22.9143L29.2437 27.7134L31.7238 27.3666L28.5709 32.5885L36.0038 26.4428C37.4524 26.4428 38.3842 27.2795 38.3842 28.5454H38.3847Z",
    fill: "#FF3C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetanoStorePin);
export default __webpack_public_path__ + "static/media/BetanoStorePin.dcbfab870e3bd08c91873deba0bada50.svg";
export { ForwardRef as ReactComponent };